module.exports = __webpack_public_path__ + "static/media/menu.d7dd277a.svg";